import {
    ChooseManufacturerData, ChooseManufacturerInput,
    ChooseManufacturerState, ChooseManufacturerValidation
} from './ChooseManufacturerState'
import {ChooseManufacturerAction} from './ChooseManufacturerActions'
import {ChooseManufacturerFeedback} from './ChooseManufacturerFeedback'
import {update} from '../../Data/ObjectHelper'
import {
    lookupValidator, mandatoryStringValidator, stringToIntValidator,
    validateInputField
} from '../../Data/FormValidation'
import * as Result from '../../Data/Result'
import {IntermediateSession} from '../../Data/IntermediateSession'
import {Manufacturer} from '../../Entities/Manufacturer.entity.evolve'
import {FeedbackLoop} from '../../Data/FeedbackLoop'

export function initChooseManufacturerPage(): ChooseManufacturerState {
    return {
        input: {
            manufacturerId: '',
        },
        validation: {
            manufacturerId: null,
        },
        submissionAttempted: false,
    }
}

interface Validators {
    manufacturer(value: string): Result.Result<'Mandatory' | 'InvalidInt' | 'LookupFailed', Manufacturer>
}

function buildValidators(manufacturers: Manufacturer[]): Validators {
    return {
        manufacturer:
            Result.compose(
                lookupValidator(manufacturer => manufacturer.id, manufacturers),
                Result.compose(
                    stringToIntValidator(),
                    mandatoryStringValidator(),
                )
            )
    }
}

type ChooseManufacturerLoop =
    FeedbackLoop<ChooseManufacturerState, ChooseManufacturerFeedback>

export function chooseManufacturerReducer(
    intermediateSession: IntermediateSession,
    state: ChooseManufacturerState,
    action: ChooseManufacturerAction
): ChooseManufacturerLoop {
    switch (action.type) {
        case 'ManufacturerChanged':
            const validators =
                buildValidators(intermediateSession.manufacturers)
            return {
                state: update(
                    {
                        input: update(
                            {manufacturerId: action.value},
                            state.input,
                        ),
                        validation: update(
                            {
                                manufacturerId: validateInputField(
                                    validators.manufacturer,
                                    state.submissionAttempted,
                                    action.value,
                                ),
                            },
                            state.validation,
                        ),
                    },
                    state,
                ),
                feedback: [],
            }
        case 'Submit':
            const validationResult =
                validate(
                    buildValidators(intermediateSession.manufacturers),
                    state.input
                )
            return ((): ChooseManufacturerLoop => {
                switch (validationResult.type) {
                    case 'Ok':
                        return {
                            state,
                            feedback: [{
                                type: 'ManufacturerChosen',
                                manufacturer: validationResult.value.manufacturer,
                            }],
                        }
                    case 'Err':
                        return {
                            state: update({
                                validation: validationResult.error,
                                submissionAttempted: true,
                            }, state),
                            feedback: [],
                        }
                }
            })()
    }
}

function validate(
    validators: Validators,
    input: ChooseManufacturerInput,
): Result.Result<ChooseManufacturerValidation, ChooseManufacturerData> {
    const validation = {
        manufacturer: validators.manufacturer(input.manufacturerId),
    }
    if (validation.manufacturer.type === 'Ok') {
        return {
            type: 'Ok',
            value: {
                manufacturer: validation.manufacturer.value,
            },
        }
    } else {
        return {
            type: 'Err',
            error: {
                manufacturerId: Result.errorToNullable(validation.manufacturer),
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ChooseManufacturer/ChooseManufacturerReducer.ts